<div>
    <gtw-sub-menus [selected_sub_task] = "taskList " 
        (showScreensEvent)="showScreens($event)"
        [pannel-position]="pannelPosition"
        [is-accordion-open]="isAccordionOpen"
        [m-setting]="mSetting">
    </gtw-sub-menus>
</div>